import React from 'react';
import { ChevronDown, User, Home } from 'lucide-react';
import { cn } from '..';
import { MdLogout } from 'react-icons/md';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar } from './ui/avatar';

interface ClientUserMenuProps {
  handleClickSignOut: () => void;
  clientEmail: string;
  onNavigateHome?: () => void;
  showEmail?: boolean;
}

export function ClientUserMenu({
  handleClickSignOut,
  clientEmail,
  onNavigateHome,
  showEmail = true,
}: ClientUserMenuProps) {
  const truncatedEmail =
    clientEmail.length > 25
      ? `${clientEmail.substring(0, 25)}...`
      : clientEmail;

  const buttonStyle =
    'group w-full flex gap-x-3 rounded-md p-2 text-sm font-medium leading-6 text-gray-800 hover:bg-primary-50';

  const homeButton = onNavigateHome && (
    <button
      className={buttonStyle}
      onClick={onNavigateHome}
    >
      <Home
        className={cn('text-gray-800', 'h-6 w-6 shrink-0')}
        aria-hidden="true"
      />
      Home
    </button>
  );

  const signOutButton = (
    <button
      className={buttonStyle}
      onClick={handleClickSignOut}
    >
      <MdLogout
        className={cn('text-gray-800', 'h-6 w-6 shrink-0')}
        aria-hidden="true"
      />
      Sign Out
    </button>
  );

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        className={cn(
          'flex items-center rounded-full bg-white',
          showEmail ? 'gap-2 px-3 py-1.5' : 'p-2',
        )}
      >
        <Avatar className="h-8 w-8 items-center justify-center bg-primary-100">
          <User
            className="text-primary-dark"
            size={18}
          />
        </Avatar>
        {showEmail && (
          <>
            <span className="text-sm text-primary-dark">{truncatedEmail}</span>
            <ChevronDown className="h-4 w-4 text-primary-dark" />
          </>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-48 rounded-xl p-3"
        align="end"
        side="bottom"
        sideOffset={5}
      >
        {homeButton && (
          <DropdownMenuItem asChild>{homeButton}</DropdownMenuItem>
        )}
        <DropdownMenuItem asChild>{signOutButton}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
